/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Appointment } from './Appointment'
import type { BusinessIntelligenceBiReportingComponent } from './BusinessIntelligenceBiReportingComponent'
import type { Company } from './Company'
import type { Department } from './Department'
import type { GlobalAddressComponent } from './GlobalAddressComponent'
import type { GlobalContentComponent } from './GlobalContentComponent'
import type { GlobalMediaComponent } from './GlobalMediaComponent'
import type { Interaction } from './Interaction'
import type { Location } from './Location'
import type { Matching } from './Matching'
import type { ProfilingFilterTagComponent } from './ProfilingFilterTagComponent'
import type { ProfilingProfileComponent } from './ProfilingProfileComponent'
import type { Referral } from './Referral'
import type { Tag } from './Tag'
import type { UploadFile } from './UploadFile'
import type { Users_Permissions_User } from './Users_Permissions_User'
export type Vacancy = {
  id?: number
  status?: Vacancy.status
  title: string
  slug?: string
  image?: UploadFile
  media?: GlobalMediaComponent
  content?: Array<GlobalContentComponent>
  address?: GlobalAddressComponent
  company?: Company
  department?: Department
  location?: Location
  manager?: Users_Permissions_User
  tags?: Array<Tag>
  lastAddressStatus?: string
  interactions?: Array<Interaction>
  profile?: ProfilingProfileComponent
  subtitle?: string
  appointments?: Array<Appointment>
  matchings?: Array<Matching>
  BusinessIntelligence?: BusinessIntelligenceBiReportingComponent
  filterTags?: Array<ProfilingFilterTagComponent>
  referrals?: Array<Referral>
  disableGeoFilter?: boolean
  createdAt?: string
  updatedAt?: string
  createdBy?: Users_Permissions_User
  updatedBy?: Users_Permissions_User
}
export namespace Vacancy {
  export enum status {
    DRAFT = 'draft',
    PUBLISHED = 'published',
    CLOSED = 'closed',
    PAUSED = 'paused',
  }
}
